import type { ComponentType } from 'react';
import type { SvgIconProps } from '@mui/material';
import FeaturedPlayListOutlinedIcon from '@mui/icons-material/FeaturedPlayListOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import Groups3OutlinedIcon from '@mui/icons-material/Groups3Outlined';
import GestureOutlinedIcon from '@mui/icons-material/GestureOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import HeightOutlinedIcon from '@mui/icons-material/HeightOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import type { BlockKind } from '@/blocks/domain/types';

/**
 * Leading icon for the kind kicker on a Block Library card (Figma `bl.library.default`, node
 * `6:3`: "kind icon + kind label"). One Material Outlined glyph per kind — recognition only, the
 * label still carries the meaning (rw-ds-components §Tag).
 *
 * Ported from the designer prototype's `blockKindIcons.tsx` (`c95995d9`). `custom` is a creatable
 * library kind. This map must stay total over every `BlockKind`.
 *
 * FLAGGED (prototype note carried over): the glyph-per-kind choices are a first pass — a
 * presentation mapping, not a DS decision — swap any that don't read.
 */
export const BLOCK_KIND_ICONS: Record<BlockKind, ComponentType<SvgIconProps>> = {
  header: FeaturedPlayListOutlinedIcon,
  customer_block: PeopleAltOutlinedIcon,
  scope_of_work: AssignmentOutlinedIcon,
  scope_fields: ListAltOutlinedIcon,
  line_items_table: ListAltOutlinedIcon,
  total: PaidOutlinedIcon,
  comments: ChatBubbleOutlineOutlinedIcon,
  terms_conditions: HandshakeOutlinedIcon,
  roles_responsibilities: Groups3OutlinedIcon,
  signature: GestureOutlinedIcon,
  price_book: RequestQuoteOutlinedIcon,
  custom_text: NotesOutlinedIcon,
  custom: ExtensionOutlinedIcon,
  spacer: HeightOutlinedIcon,
  cover_page: AutoStoriesOutlinedIcon
};
